var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.56662 10.0583C6.56662 9.71663 6.84995 9.43329 7.19162 9.43329H11.7583V2.38329C11.75 1.98329 11.4333 1.66663 11.0333 1.66663C6.12495 1.66663 2.69995 5.09163 2.69995 9.99996C2.69995 14.9083 6.12495 18.3333 11.0333 18.3333C11.425 18.3333 11.75 18.0166 11.75 17.6166V10.675H7.19162C6.84162 10.6833 6.56662 10.4 6.56662 10.0583Z",
    fill: "#878787"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1167 9.61668L14.75 7.24167C14.5083 7.00001 14.1083 7.00001 13.8667 7.24167C13.625 7.48334 13.625 7.88334 13.8667 8.12501L15.1667 9.42501H11.75V10.675H15.1583L13.8583 11.975C13.6167 12.2167 13.6167 12.6167 13.8583 12.8583C13.9833 12.9833 14.1417 13.0417 14.3 13.0417C14.4583 13.0417 14.6167 12.9833 14.7417 12.8583L17.1083 10.4833C17.3583 10.25 17.3583 9.85834 17.1167 9.61668Z",
    fill: "#878787"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.2f97a427d7958a00e9048409ac7602e5.svg";
export { ForwardRef as ReactComponent };